import { Scale } from '@blade/common/utils/auto-scale';
import colors from '@/styles/color.scss';
export const Legend_Config = {
    textStyle: {
        fontSize: 13 * Scale,
    },
    itemWidth: 10 * Scale,
    itemHeight: 10 * Scale,
};
export const Tooltip_Config = {
    textStyle: { fontSize: 14 * Scale, color: colors.portraitCenterTextStyle },
    backgroundColor: colors.$white,
    extraCssText: `box-shadow: 0 0 3px ${colors.taskShadows};`,
    className: 'echarts-tooltip echarts-tooltip-white',
};
const AxisLineStyle = { width: Scale, color: colors.portraitCenterBarhConfigInside };
export const AxisConfig = {
    axisLabel: { fontSize: 12 * Scale, color: colors.portraitCenterBarhConfigInside },
    splitLine: { lineStyle: { width: AxisLineStyle.width, color: colors.portraitCenterTextStyleSplitLine } },
    axisLine: { lineStyle: AxisLineStyle },
    axisTick: { show: false }
};
export const SeriesLineStyle = {
    lineStyle: {
        width: 2 * Scale,
    },
    symbol: 'circle',
    symbolSize: 4 * Scale,
    showSymbol: false
};
